class DeleteCompanyContactModalController {
    constructor(userService) {
        this.userService = userService;
    }
    $onInit() {
        this.userDetails = this.resolve.userDetails;
        this.userDetails.name = this.userDetails.firstName + this.userDetails.lastName;
        this.deleteContactUserInfo = this.resolve.deleteContactUserInfo;
        this.selectedExistingContact = null;
        this.isSaveClicked = false;
        this._setDeleteContactInfo();
        this.callbackObject = { callbackType: 'cancel', entity: { primaryContact: null } };
    }
    _setDeleteContactInfo() {
        if (this.deleteContactUserInfo.contactsList) {
            this.deleteContactUserInfo.contactsList.map(contact => {
                if (!contact.name || contact.name == '') {
                    contact.name = contact.firstName + " " + contact.lastName;
                }
            });
        }
    }
    removeContact() {
        this.isSaveClicked = true;
        if (this.deleteContactUserInfo.contactsList.length == 0) {
            this.closeModal();
        }
        else {
            if (this.selectedExistingContact) {
                this.closeModal();
            }
        }
    }
    existingUserChanged() {
        this.isSaveClicked = false;
        this.callbackObject.entity.primaryContact = this.selectedExistingContact ? this.selectedExistingContact : null;
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
DeleteCompanyContactModalController.$inject = ['userService'];
import * as TEMPLATE from 'raw-loader!./delete-company-contact-modal.html';
export const DeleteCompanyContactModalComponent = {
    selector: 'deleteCompanyContactModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DeleteCompanyContactModalController,
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=delete-company-contact-modal.js.map